import { ReadOnlyStepProps } from "../useStepEditor";
import { useAutomationStep } from "../../../automations/hooks/useAutomationStep";
import { Block } from "../../../../components/atoms";
import { ReadOnlyMessage } from "../../components/ReadOnlyMessage";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { Icon, Stack, Title } from "@introist/react-foundation/v2";
import { isEmpty } from "lodash";
import { AttachmentViewer } from "modules/workflows/blocks/Attachments/AttachmentViewer";

export const SlackDirectMessageViewer = ({ stepId }: ReadOnlyStepProps) => {
  const { step } = useAutomationStep({ id: stepId });

  if (!step || !step.resolvedData) return <div />;

  const resolvedData = step.resolvedData as any;

  return (
    <>
      <Block blended compact>
        <StepEditorAccordion title="Sender & Recipients">
          <StepEditorAccordion.Row label="From">
            <Stack>
              {resolvedData.isBot ? <Icon name="robot" /> : <Icon name="person" />}
              <Title variant="bold">{resolvedData.resolvedSenderName}</Title>
            </Stack>
          </StepEditorAccordion.Row>
          <StepEditorAccordion.Row label="To">
            <Stack vertical>
              {(resolvedData.resolvedUsers as { id: string; name: string }[]).map(recipient => (
                <Stack key={recipient.id}>
                  <Icon name="person" />
                  <Title variant="bold">{recipient.name}</Title>
                </Stack>
              ))}
            </Stack>
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>
      <Block blended compact>
        <ReadOnlyMessage message={resolvedData.resolvedMessage!.html} />
      </Block>
      {!isEmpty(resolvedData.attachments) && (
        <Block blended compact>
          <AttachmentViewer attachments={resolvedData.attachments} />
        </Block>
      )}
    </>
  );
};
